export enum TripLegSelectorMode {
  edit = 'edit',
  summary = 'summary',
}
